import React from "react";
import DateFormatting from "../../common_components/DateFormatting";
import UserIcon from "./UserIcon"
import { Link } from "react-router-dom";

function CompletedSessionUserCard(props) {

    const [date, time] = DateFormatting.parseISOStringToReadableDateAndTime(props.session.start_time, props.timezone);
    const longDate = DateFormatting.parseISOStringToLongDate(props.session.start_time, props.timezone);

    return (
        <Link className="completed-session-card" to={"/missions/" + props.missionId + "/sessions/" + props.session.id}>
            <UserIcon />
            <div className="completed-session-card-text-div">
                <div className="completed-session-card-name">
                    {props.session.first_name}
                </div>
                <div className="completed-session-card-date-container">
                    <div className="completed-session-card-date">
                        {longDate}
                    </div>
                    <div className="completed-session-card-date">
                        {time}
                    </div>
                </div>
            </div>
        </Link>
    )
}


export default CompletedSessionUserCard;